import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * Unified icon + title + message (+ optional retry) markup for loading,
 * empty, and error states — replacing the divergent ad hoc markup
 * previously duplicated per page (Home's maintenance block, Financial
 * Analysis section errors, Submitted Files' empty state, etc.).
 */
@Component({
  selector: 'app-state-panel',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './state-panel.component.html',
  styleUrl: './state-panel.component.scss',
})
export class StatePanelComponent {
  @Input() icon = 'info';
  @Input({ required: true }) title = '';
  @Input() message = '';
  @Input() retryLabel?: string;
  @Input() testId?: string;

  @Output() readonly retry = new EventEmitter<void>();
}
